import { render, staticRenderFns } from "./ueditor.vue?vue&type=template&id=4c517506&"
import script from "./ueditor.vue?vue&type=script&lang=js&"
export * from "./ueditor.vue?vue&type=script&lang=js&"
import style0 from "./ueditor.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports